var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.795898,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_radial_6003_1171)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 20.2959H21.3825M11.25 13.5459V24.0459C11.25 24.8743 11.9216 25.5459 12.75 25.5459H23.25C24.0784 25.5459 24.75 24.8743 24.75 24.0459V16.5459C24.75 15.7175 24.0784 15.0459 23.25 15.0459L12.75 15.0459C11.9216 15.0459 11.25 14.3743 11.25 13.5459ZM11.25 13.5459C11.25 12.7175 11.9216 12.0459 12.75 12.0459H21.75M21.75 20.2959C21.75 20.503 21.5821 20.6709 21.375 20.6709C21.1679 20.6709 21 20.503 21 20.2959C21 20.0888 21.1679 19.9209 21.375 19.9209C21.5821 19.9209 21.75 20.0888 21.75 20.2959Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6003_1171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1354 36.7959) rotate(-12.8654) scale(31.9054 30.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#299FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.df2ec1dbb4c6e2d2c2dc148ac9a96cff.svg";
export { ForwardRef as ReactComponent };